// extracted by mini-css-extract-plugin
module.exports = {"deleteList":"styles_deleteList__3VD1M","select":"styles_select__3NbR7"};